import type { Entry } from 'contentful'

export const getEntryTypeId = <T>(entry: Entry<T>): string =>
  entry?.sys?.contentType?.sys?.id
